import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import { StyleSheet, Text, View } from 'react-native';

import { t } from 'state/intl/translations';
import { useOrderContext } from 'state/order';
import { primitive, spacing } from 'styles/constants';
export const PickupNowEtaIndicator = () => {
  const { pickupDate } = useOrderContext();

  if (pickupDate) {
    return null;
  }

  return (
    <View style={styles.container}>
      <MaterialIcons name="access-time-filled" size={12} color={primitive.$bbqBrown} />
      <Text style={styles.text}>{t('pickupNowEta')}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: primitive.$blackOpacity4,
    borderRadius: 5,
    paddingHorizontal: spacing.$2,
    marginLeft: spacing.$1,
    marginTop: spacing.$1_5,
  },
  text: {
    fontSize: 12,
    color: primitive.$bbqBrown,
    marginLeft: spacing.$1,
    fontFamily: primitive.fontFamily.$body,
    lineHeight: 24,
  },
});
